"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISINCOURTUPDATESTYPES = void 0;
const updates_1 = require("../updates");
exports.ISINCOURTUPDATESTYPES = [
    updates_1.UpdateType.AWAITINGCIVILCOURT,
    updates_1.UpdateType.AWAITINGFOGEDREKVISITION,
    updates_1.UpdateType.ISINCIVILCOURT,
    updates_1.UpdateType.ISINFOGEDRETTEN,
    updates_1.UpdateType.AWAITINGSTAEVNING,
    updates_1.UpdateType.PHONEMEETING,
];
//# sourceMappingURL=index.js.map